<template>
    <div class="widget-time-frame">
        <div class="time-frame-types w-max" dir="ltr">
            <slot name="frame-types" />
        </div>
        <div :class="{ 'opacity-50 pointer-events-none': !timeFrameType }">
            <div
                v-if="componentTypeKey !== 'TimePeriod'"
            >
                <RedesignFormLabel
                    :label="t('widget.time.interval')"
                    class="mb-2"
                />
                <component
                    :is="componentType"
                    v-model="timeModel"
                    :widget-time-options="widgetTimeOptions"
                    v-bind="$attrs"
                />
            </div>
            <div v-else>
                <component
                    :is="componentType"
                    v-model="timeModel"
                    v-bind="$attrs"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { capitalizeFirstLetter } from '@/helpers/util'
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import WidgetTimeAbsolute from '@/components/RedesignComponents/Widgets/Common/WidgetTime/WidgetTimeAbsolute.vue'
import WidgetTimeRelative from '@/components/RedesignComponents/Widgets/Common/WidgetTime/WidgetTimeRelative.vue'
import WidgetTimePeriod from '@/components/RedesignComponents/Widgets/Common/WidgetTime/WidgetTimePeriod.vue'
import { WidgetTime } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'

defineOptions({
    inheritAttrs: false
})

const { t } = useI18n()

const COMPONENTS = {
    TimeAbsolute: WidgetTimeAbsolute,
    TimeRelative: WidgetTimeRelative,
    TimePeriod: WidgetTimePeriod
}

const props = withDefaults(
    defineProps<{
        modelValue: WidgetTime
        timeFrameType?: string | null
        widgetTimeOptions?: Array<Record<string, string>>
    }>(),
    {
        timeFrameType: 'relative',
        widgetTimeOptions: () => []
    }
)

const emit = defineEmits<{
    (e: 'update:modelValue', v: WidgetTime): void
}>()

const timeModel = useVModel(props, 'modelValue', emit)

const componentTypeKey = computed(() => {
    return ('Time' + capitalizeFirstLetter(props.timeFrameType || 'relative')) as keyof typeof COMPONENTS
})
const componentType = computed(() => {
    return COMPONENTS[componentTypeKey.value]
})
</script>